export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x94041db6deC15f79666B07846c13e6F7341b4a80",
  eulerSwapV1Implementation: "0x4D57F54582b333E4184A3cF40d1D61FE6D70c35D",
  eulerSwapV1Periphery: "0xb2237DC86B184e50Fc2F8b028B2b7AE192ef2566",
} as const
